export default {
    props: [
        // * Texto que será exibido no estado inicial do dropdown
        'placeholder',
        // * Array que será renderizado nas options do select
        'arrayRender',
        // * Condição booleana para desabilitar e ativar o dropdown
        'disabled'
    ],

    data() {
      return {
        // * Condição para as options aparecer e desaparecer
        visibleOptions:     false,
        // * Texto que será exibido no estado inicial do dropdown
        placeholder:        this.placeholder,
        // * Value do item selecionado
        valueSelected:      "",
        // * Caption do item selecionado
        captionSelected: "",
        // * Array que será render izado nas options do select
        arrayRender: this.arrayRender,
        // * Condição booleana para desabilitar e ativar o dropdown
        disabled:           this.disabled
    }
    },
    mounted(){
      this.OnClickStatus();


  },
  watch: {
      disabled: function (novoValor, valorAntigo) {
        this.visibleOptions = true;
      },
    arrayRender: function (novoValor, valorAntigo) {
        this.captionSelected  = "";
        this.valueSelected = "";
        this.visibleOptions   = true;
      },
    },
    methods: {
        OnClickStatus() {
            return this.visibleOptions == false ? this.visibleOptions = true : this.visibleOptions = false;
      },

        clickHandlerOptions(caption,value) {
          // this.valueSelected = value;
          this.valueSelected = value;
          this.captionSelected = caption;
          this.OnClickStatus();
          this.$emit('ClickHandler', this.captionSelected,this.valueSelected );
            return;
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/Global/dropdownV2/dropdownV2.js